import {IAgreementParser} from '../helpers/agreements/agreementParser';
import {IAgreementParserFactory} from '../helpers/agreements/agreementParser';
import {IParsedAgreement} from '../helpers/agreements/agreementParser';

interface IAgreementOptions {
	memberId?: number;
	partyId: number;
	agreementId: number;
	contractTypeId: number;
	isSigned: boolean;
	agreementType: string;
	paymentType: string;
}

export interface IAgreementService {
	getAgreement(memberId: number | undefined, partyId: number, agreementId: number, source: string, agreementType: string,
		paymentType: string, isSigned: boolean): ng.IPromise<IParsedAgreement>;
}

export default ['$q', 'AgreementResource', 'SignedAgreementResource', 'NonMemberSignedAgreementResource', 'agreementParserFactory',
	($q: ng.IQService,
			Agreements: MyAccountApi.IAgreementResource,
			SignedAgreements: MyAccountApi.ISignedAgreementResource,
			NonMemberSignedAgreements: MyAccountApi.INonMemberSignedAgreementResource,
			AgreementParserFactory: IAgreementParserFactory) => {

		function getAgreementParser(source: string): IAgreementParser {
			return AgreementParserFactory.getParser(source);
		}

		function fetchAgreement(options: IAgreementOptions): ng.IPromise<MyAccountApi.IAgreement> {
			const dfd = $q.defer<MyAccountApi.IAgreement>();

			if (options.isSigned) {
				if (options.memberId) {
					SignedAgreements.get(options, (agreement: MyAccountApi.IAgreement) => {
						dfd.resolve(agreement);
					});
				} else {
					NonMemberSignedAgreements.get(options, (agreement: MyAccountApi.IAgreement) => {
						dfd.resolve(agreement);
					});
				}
			} else {
				Agreements.get(options, (agreement: MyAccountApi.IAgreement) => {
					dfd.resolve(agreement);
				});
			}

			return dfd.promise;
		}

		function getParsedAgreement(agreement: MyAccountApi.IAgreement, source: string): IParsedAgreement {
			const parser = getAgreementParser(source);

			return parser.parse(agreement, source);
		}

		function getAgreement(memberId: number, partyId: number, agreementId: number, source: string,
				agreementType: string, paymentType: string, isSigned: boolean): ng.IPromise<IParsedAgreement> {
			const options: IAgreementOptions = {
				memberId,
				partyId,
				agreementId,
				agreementType: source,
				contractTypeId: agreementId,
				isSigned,
				paymentType
			};

			return fetchAgreement(options).then((agreement: MyAccountApi.IAgreement) => {
				return getParsedAgreement(agreement, source);
			});
		}

		return {
			getAgreement
		};
	}];
